import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '01',
    title: 'Limpieza',
    desc: 'Descargás el PDF y realizás la limpieza de alacena con la Guía de Saboteadores.'
  }, {
    num: '02',
    title: 'Reset',
    desc: 'Aplicás el Reset Salino cada mañana para estabilizar tus adrenales.'
  }, {
    num: '03',
    title: 'Resultados',
    desc: 'Seguís el plan de comidas de 7 días y observás cómo tu ropa empieza a quedarte floja nuevamente.'
  }];
  return <section className="py-20 md:py-32 bg-beige/30" data-id="element-114">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-115">
        <FadeIn data-id="element-116">
          <div className="text-center mb-16" data-id="element-117">
            <span className="inline-block text-gold text-xs font-semibold tracking-[0.2em] uppercase mb-4" data-id="element-118">
              El Proceso
            </span>
            <h2 className="font-serif text-3xl md:text-4xl text-teal" data-id="element-119">
              Cómo funciona
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-120">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[1px] bg-teal/10 -z-10" data-id="element-121"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={0.1 * index} data-id="element-122">
              <div className="flex flex-col items-center text-center" data-id="element-123">
                <div className="w-24 h-24 rounded-full bg-cream border border-teal/10 flex items-center justify-center mb-6 shadow-sm" data-id="element-124">
                  <span className="font-serif text-3xl text-gold" data-id="element-125">
                    {step.num}
                  </span>
                </div>
                <h3 className="font-serif text-xl text-teal mb-3" data-id="element-126">
                  {step.title}
                </h3>
                <p className="text-teal/70 font-light leading-relaxed max-w-xs" data-id="element-127">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}